export const programmes = [
  {
    key: "events-tracker",
    value: "SEIMS Events App",
    description:
      "Science engagement and related event organisers can now effortlessly register their events and collect participant data with the help of the SEIMS Events App. You can view real-time event data and participation analytics through the Android app.",
    subscribedDesc:
      "Register your events and collect participant data with the help of the SEIMS Events App.",
    image: require("../assets/event-programme.png"),
    subscriptionImage: require("../assets/event-programme-yel.png"),
    // launchLink: "/events/home", Commented out because the page it redirects to is still empty
    launchLink: "/events",
    link: "/events",
    role: "EVENT_ORGANISER",
    imageWidth: 335,
    imageHeight: 246,
    offlineText: "Coming Soon",
    active: true,
  },
  {
    key: "nys-programme",
    value: "National Youth Service (NYS)",
    description:
      "A portal for unemployed science graduates under the age of 35 to express their interests and volunteer to advance science engagement through community service. The DSTI-NYS hosts volunteers for a 12-month period, allowing them to gain workplace experience while they receive a monthly stipend to help with daily expenses.",
    subscribedDesc:
      "A portal for science graduates to volunteer to advance science engagement through community service.",
    image: require("../assets/nys-programme.png"),
    subscriptionImage: require("../assets/nys-programme-yel.png"),
    launchLink: "/nys/home",
    link: "/nys/landing",
    role: "NYS_CANDIDATE",
    imageWidth: 353,
    imageHeight: 217,
    offlineText: "Coming Soon",
    active: true,
  },
  {
    key: "citizen-science",
    value: "Citizen Science",
    description:
      "A portal that enables researchers who are leading collaborative research projects with the citizen science approach document their work in order to help paint a picture of the scope of these projects nationwide. ",
    subscribedDesc:
      "A portal for researchers who are leading collaborative research projects with the citizen science approach document their work ",
    image: require("../assets/citizen-science-programme.png"),
    subscriptionImage: require("../assets/cit-sci-yellow.png"),
    launchLink: "/my-projects",
    link: "/citisci",
    role: "CITIZEN_SCIENTIST",
    imageWidth: 356,
    imageHeight: 217,
    offlineText: "Coming Soon",
    active: true,
  },
  {
    key: "volunteer-scientist",
    value: "Volunteer Scientists/STEM Professionals",
    description:
      "A platform where scientists and other STEM professionals can indicate their willingness to volunteer to help the science engagement programme achieve its goals. The portal exposes the volunteers to available opportunities to give back to their country.",
    subscribedDesc:
      "A portal for STEM professionals where they can indicate their willingness to volunteer to help the science engagement programme achieve its goals",
    image: require("../assets/volunteer-b.png"),
    subscriptionImage: require("../assets/volunteer-y.png"),
    launchLink: "/volunteer-scientist/home",
    link: "/volusci",
    role: "VOLUNTEER_SCIENTIST",
    imageWidth: 269,
    imageHeight: 266,
    offlineText: "Coming Soon",
    active: true,
  },
];

export const nysIntakeMessage = {
  "Previous-placement": {
    subject: "Ineligible for Reapplication",
    body: "You are not eligible to reapply for the NYS programme, as you have previously participated. However, you can still access and view your profile details.",
  },
  "Previous-consideration": {
    subject: "Application under In-Progress/Review",
    body: "You have already applied for the NYS programme and your application is under review. In the meantime, you can still update your details.",
  },
  "Previous-rejection": {
    subject: "Applications now Open",
    body: "A new call for NYS applications is now open! If you still wish to apply, you can still update your details and submit your application.",
  },
  "Previous-withdrawal": {
    subject: "Applications now Open",
    body: "A new call for NYS applications is now open! If you still wish to apply, you can still update your details and submit your application.",
  },
  "Current-placement": {
    subject: "Ineligible for Reapplication",
    body: "You are not eligible to reapply for the NYS programme, as you have already participated. However, you can still access and view your profile details.",
  },
  "Current-consideration": {
    subject: "Application under In-Progress/Review",
    body: "You have already applied for the NYS programme and your application is under review. In the meantime, you can still update your details.",
  },
  "Current-rejection": {
    subject: "Application Unsuccessful",
    body: "Unfortunately your application for this NYS intake was unsuccessful.",
  },
  "Current-withdrawal": {
    subject: "Application Widrawn",
    body: " You have withdrawn your application for this NYS intake and cannot resubmit it. However, you can still view your details.",
  },
  "Current-submission": {
    subject: "Application Submitted",
    body: " Your application has been successfully submitted. However, you can still update your details as needed.",
  },
  "Closed-window": {
    subject: "Submission Period has Closed",
    body: "NYS application closing date has passed, last day for applications was /. However, you can still update your details.",
  },
  "No-intake": {
    subject: "Applications Closed",
    body: "Applications are currently closed. Please be on the lookout for new a call.",
  },
  "Closed-intake": {
    subject: "Applications Closed",
    body: "Applications closed on ",
  },
  "Scheduled-intake": {
    subject: "New Application Opening Soon",
    body: "Applications will open on ",
  },
  "Open-intake": {
    subject: "Open for Applications",
    body: "Applications are closing on ",
  },
  "Future-outlook": {
    subject: "Future Outlook",
    body: "Please be on the lookout for new a new call.",
  },
};
